
import React from 'react';
import { Drawer } from '@/components';
import { render as reactRender, unmount as reactUnmount } from '@/components/modal/embellish/render';
import destroyFns from '@/components/modal/basics/destroyFns'

import type { DrawerProps } from 'antd/es/drawer'; 

export interface Props extends DrawerProps {
  content?: (config: Props) => React.ReactNode
}


export type ConfigUpdate = Props | ((prevConfig: Props) => Props);

/**
* @description 模态框静态函数类型
*/
const staticRender = (config: Props) => {

  let currentConfig: Props = { ...config,  open: true, onClose: close };

  const container = document.createDocumentFragment();

  /**
  * @description 渲染函数
  * @param props 属性
  */
  function render(props: Props) {
    const { content, ...otherProps } = props;
    reactRender(<Drawer {...otherProps}>{content?.({ ...otherProps })}</Drawer>, container);
  }

  /**
  * @description 关闭方法
  * @param e 合成事件
  */
  function close(e: React.MouseEvent | React.KeyboardEvent): void {
    update({
      ...currentConfig,
      open: false,
      afterOpenChange: (open) => {
        if (open) return;
        if (typeof config.afterOpenChange === 'function') {
          config.afterOpenChange(open);
        }
        destroy();
      }
    });

    config.onClose && config.onClose(e);
  }

  function update(configUpdate: ConfigUpdate): void {
    if (typeof configUpdate === 'function') {
      currentConfig = configUpdate(currentConfig);
    } else {
      currentConfig = {
        ...currentConfig,
        ...configUpdate
      };
    }
    render(currentConfig);
  }

  function destroy() {
    reactUnmount(container);
  }

  // 初始渲染
  render(currentConfig);
  destroyFns.push(close);

  return {
    destroy: close,
    update
  };
}



export default staticRender;
